import {useMutation, useQueryClient} from "@tanstack/react-query";
import {create} from "../../../app/setters/create.js";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {useState} from "react";

export const useDodajPozycjeSlownika = () => {

    const [slownikData, setSlownikData] = useState({})
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => create(`/slowniki/${data.slownik}`, {...data?.data}),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },
        onMutate: (data) => {
            setSlownikData(data?.slownik)
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: [`pozycje_slownika__${slownikData}`]
            })
        },
        onSuccess: ({message}) => {
            navigate(`/oper/slownik/${slownikData}/lista`)
            toast.success(message)
        }
    })
}